import React from "react";
import { Button, IconButton } from "@mui/material";
function TableAction({ icon, action, text, ...rest }) {
  return (
    <>
      {text ? (
        <Button onClick={action} {...rest} endIcon={icon} sx={action.style}>
          {text}
        </Button>
      ) : (
        <IconButton onClick={action} {...rest} sx={action.style}>
          {icon}
        </IconButton>
      )}
    </>
  );
}

export default TableAction;
